import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Wrapper = styled.div`
  display: grid;
  gap: 20px;
  grid-template:
    'header' min-content
    'groups' 1fr
    'footer' min-content
    / 1fr;
  height: 100%;
  padding: 20px 0 20px 0;
`;

export const Header = styled.div`
  grid-area: header;
  padding-right: 20px;
`;

export const StartConversationLink = styled(Link)`
  all: unset;
  background-color: ${({ theme }) => theme.colors.primary};
  border-radius: 4px;
  box-sizing: border-box;
  color: ${({ theme }) => theme.colors.bodyBg};
  cursor: pointer;
  display: flex;
  flex-flow: row nowrap;
  font-size: 14px;
  font-weight: 400;
  line-height: 26px;
  margin-bottom: 10px;
  padding: 5px 10px;

  &:hover {
    color: ${({ theme }) => theme.colors.bodyBg};
    text-decoration: none;
  }

  &::after {
    content: '+';
    font-size: 24px;
    margin-left: auto;
  }
`;

export const Sections = styled.div`
  gap: 20px;
  display: flex;
  flex-flow: column nowrap;
  overflow: hidden;
  place-self: stretch stretch;
`;

export const Footer = styled.div`
  grid-area: footer;
  padding-right: 20px;
  position: relative;
`;
